"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DampenedEffectHandler = exports.DampenedEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const AttributeType_1 = require("../../enums/AttributeType");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const MaxAttributeDecrease_1 = require("./MaxAttributeDecrease");
const MaxAttributeIncrease_1 = require("./MaxAttributeIncrease");
class DampenedEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Dampened;
        this.__typeName = "Dampened";
        this.name = "Dampened";
        this.harmful = true;
    }
}
exports.DampenedEffectArgs = DampenedEffectArgs;
DampenedEffectArgs.CustomText = "Reduced critical multiplier and healing.";
let DampenedEffectHandler = class DampenedEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyDebuffs({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            hidden: true,
            effects: [
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(AttributeType_1.AttributeType.CriticalDamageMultiplier, 20),
                    supernatural: true,
                },
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.PercentHealingReceivedDecrease, 20),
                    supernatural: true,
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        ;
        (state.meta.effectIds || []).forEach(effectId => container.cancelEffect(sequence, effectId));
    }
};
DampenedEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Dampened)
], DampenedEffectHandler);
exports.DampenedEffectHandler = DampenedEffectHandler;
